<div class="loading" [ngClass]="{ active: isLoading }"></div>
<div *ngFor="let spinner of spinners" id="spinner" class="{{ cssClass(spinner) }}" role="spinner">
  <img src="./../../../../assets/images/tecomec/spinner-tecomec.svg" alt="" />
  <p>{{ spinner.message }}</p>
</div>
